import {
  BaseResponse,
  parseErrorContainer,
  recursiveDasherizeKeys,
  type SecurityQuestion,
} from "../../tastyworks"
import type HttpClient from "../../tastyworks/http"

interface UserParams {
  username: string
  name: string
  password: string
  securityQuestions: SecurityQuestion[]
}

export class InvitationService {
  constructor(private readonly httpClient: HttpClient) {}

  async acceptWithToken(
    userTeamId: string,
    invitationToken: string,
    params: UserParams
  ): Promise<BaseResponse> {
    const helper = await this.httpClient.patch(
      `/user-teams/${userTeamId}/invitations/${invitationToken}`,
      recursiveDasherizeKeys(params)
    )

    const response = new BaseResponse()
    parseErrorContainer(helper, response)

    return response
  }
}
